import * as Alt from 'alt';

const alt = new Alt();

export default alt;



// WEBPACK FOOTER //
// ./src/components/alt.js